import 'client-only';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { DATA_KEYS } from '@/consts/dataKeys';
import { type Card } from '@/types/productSelectionAndCheckout/types';

export const useRxFullSizeItemId = () => {
  let rxCard: Card | undefined;
  try {
    const productSelectionData = useDataProvider(DATA_KEYS.productSelection);
    rxCard = productSelectionData.rxCard;
  } catch (e) {
    // do nothing
  }
  return rxCard?.fullSizeItemId;
};
